var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135.71 136.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "24.52 42.13 16.98 38.88 9.45 42.13 9.45 23.42 24.52 23.42 24.52 42.13",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.52 42.13 16.98 38.88 9.45 42.13 9.45 23.42 24.52 23.42 24.52 42.13",
    style: {
      fill: "#dff3fa"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "24.52 42.13 16.98 38.88 9.45 42.13 9.45 23.42 24.52 23.42 24.52 42.13",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.98,16.82c0,1.64-1.86,2.96-2.34,4.44s.22,3.69-.71,4.97-3.22,1.27-4.51,2.21-1.96,3.11-3.49,3.61-3.31-.87-4.95-.87-3.47,1.35-4.95,.87-2.22-2.68-3.49-3.61-3.57-.92-4.51-2.21-.21-3.44-.71-4.97-2.34-2.8-2.34-4.44,1.86-2.96,2.34-4.44-.22-3.69,.71-4.97,3.22-1.27,4.51-2.21,1.96-3.11,3.49-3.61,3.31,.87,4.95,.87,3.47-1.35,4.95-.87,2.22,2.68,3.49,3.61,3.57,.92,4.51,2.21,.21,3.44,.71,4.97,2.34,2.8,2.34,4.44Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.98,16.82c0,1.64-1.86,2.96-2.34,4.44s.22,3.69-.71,4.97-3.22,1.27-4.51,2.21-1.96,3.11-3.49,3.61-3.31-.87-4.95-.87-3.47,1.35-4.95,.87-2.22-2.68-3.49-3.61-3.57-.92-4.51-2.21-.21-3.44-.71-4.97-2.34-2.8-2.34-4.44,1.86-2.96,2.34-4.44-.22-3.69,.71-4.97,3.22-1.27,4.51-2.21,1.96-3.11,3.49-3.61,3.31,.87,4.95,.87,3.47-1.35,4.95-.87,2.22,2.68,3.49,3.61,3.57,.92,4.51,2.21,.21,3.44,.71,4.97,2.34,2.8,2.34,4.44Z",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.98,
    cy: 16.82,
    r: 11.43,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.98 10.74 18.96 14.74 23.38 15.39 20.18 18.5 20.94 22.9 16.98 20.83 13.03 22.9 13.79 18.5 10.59 15.39 15.01 14.74 16.98 10.74",
    style: {
      fill: "#dff3fa"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 90.56,
    cy: 91.45,
    r: 39.4,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.2,105.09c-7.53,7.53-19.74,7.53-27.27,0",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.93,77.82c7.53-7.53,19.74-7.53,27.27,0",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.56,
    cy: 91.45,
    r: 3.35,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.39,
    y1: 60.63,
    x2: 115.46,
    y2: 66.56,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.67,
    y1: 116.35,
    x2: 59.74,
    y2: 122.28,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.39,
    y1: 122.28,
    x2: 115.46,
    y2: 116.35,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.27,
    y1: 114.21,
    x2: 90.27,
    y2: 105.83,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.27,
    y1: 76.49,
    x2: 90.27,
    y2: 68.1,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.22,
    y1: 91.16,
    x2: 75.6,
    y2: 91.16,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.94,
    y1: 91.16,
    x2: 113.32,
    y2: 91.16,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.67,
    y1: 66.56,
    x2: 59.74,
    y2: 60.63,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.97,
    y1: 91.45,
    x2: 55.36,
    y2: 91.45,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.77,
    y1: 91.45,
    x2: 134.16,
    y2: 91.45,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.97,
    y1: 91.45,
    x2: 55.36,
    y2: 91.45,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.77,
    y1: 91.45,
    x2: 134.16,
    y2: 91.45,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.56,
    y1: 47.86,
    x2: 90.56,
    y2: 56.25,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.56,
    y1: 126.66,
    x2: 90.56,
    y2: 135.04,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.63,
    cy: 113.39,
    r: 0.84,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 111.01,
    r: 0.84,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.37,
    cy: 108.64,
    r: 0.84,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.16,
    cy: 74.86,
    r: 0.84,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.53,
    cy: 72.49,
    r: 0.84,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.9,
    cy: 70.11,
    r: 0.84,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.63,
    cy: 70.11,
    r: 0.84,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 72.49,
    r: 0.84,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.37,
    cy: 74.86,
    r: 0.84,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.16,
    cy: 108.64,
    r: 0.84,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.53,
    cy: 111.01,
    r: 0.84,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.9,
    cy: 113.39,
    r: 0.84,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.71,
    y1: 95.6,
    x2: 92.94,
    y2: 93.82,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.19,
    y1: 89.08,
    x2: 86.42,
    y2: 87.3,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.42,
    y1: 95.6,
    x2: 88.19,
    y2: 93.82,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.94,
    y1: 89.08,
    x2: 94.71,
    y2: 87.3,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M53.64,29.48c5.21,0,5.21,7.87,10.41,7.87s5.21-7.87,10.41-7.87,5.21,7.87,10.42,7.87,5.21-7.87,10.41-7.87,5.21,7.87,10.42,7.87,5.21-7.87,10.42-7.87",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "6.01 67.42 6.01 113.64 20.85 113.64",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.01,
    cy: 67.42,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.64,.98c5.21,0,5.21,7.87,10.41,7.87s5.21-7.87,10.41-7.87,5.21,7.87,10.42,7.87,5.21-7.87,10.41-7.87,5.21,7.87,10.42,7.87,5.21-7.87,10.42-7.87",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.63,15.04l-3.79-2.77-3.64,2.77v10.49h7.43V15.04Zm-4.51-.73c0-.4,.33-.73,.73-.73s.73,.33,.73,.73-.33,.73-.73,.73-.73-.33-.73-.73Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.08,15.04l-3.79-2.77-3.64,2.77v10.49h7.43V15.04Zm-4.51-.73c0-.4,.33-.73,.73-.73s.73,.33,.73,.73-.33,.73-.73,.73-.73-.33-.73-.73Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.53,15.04l-3.79-2.77-3.64,2.77v10.49h7.43V15.04Zm-4.51-.73c0-.4,.33-.73,.73-.73s.73,.33,.73,.73-.33,.73-.73,.73-.73-.33-.73-.73Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "83.57 17.53 96.34 17.53 96.34 13.32 108.95 13.32",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.47,
    cy: 13.32,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.17,
    cy: 18.05,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "81.47 20.68 91.45 20.68 91.45 25.4 98.97 25.4 98.97 18.05 100.55 18.05",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "85.67 23.3 85.67 28.55 102.65 28.55 102.65 25.93 106.32 25.93",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.42,
    cy: 25.93,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 110.04,
    y1: 40.12,
    x2: 110.04,
    y2: 44.85,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.1,
    y1: 40.12,
    x2: 132.1,
    y2: 51.68,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "132.1 40.12 132.1 44.85 107.42 44.85",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.1,
    cy: 39.6,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.04,
    cy: 39.6,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.07,
    y1: 40.12,
    x2: 121.07,
    y2: 44.85,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.07,
    cy: 39.6,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.1,
    cy: 51.68,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 124.97,
    y: 19.4,
    width: 1.61,
    height: 4.59,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.77,
    cy: 11.86,
    r: 7.98,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.77,
    cy: 11.86,
    r: 7.98,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.77,
    cy: 11.86,
    r: 6.17,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.07,11.86c0-1.73,.94-3.25,2.33-4.06",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.74,
    y: 21.51,
    width: 4.07,
    height: 8.61,
    rx: 2.03,
    ry: 2.03,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.74,
    y: 21.51,
    width: 4.07,
    height: 8.61,
    rx: 2.03,
    ry: 2.03,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.16,
    y: 63.46,
    width: 3.63,
    height: 17.8,
    transform: "translate(90.34 54.39) rotate(90)",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.44,
    y: 71.22,
    width: 3.63,
    height: 14.37,
    transform: "translate(94.67 62.15) rotate(90)",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.66,
    y: 79.05,
    width: 3.63,
    height: 10.8,
    transform: "translate(98.93 69.98) rotate(90)",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.42,
    y: 82.34,
    width: 3.63,
    height: 16.31,
    transform: "translate(107.73 73.27) rotate(90)",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.22,
    y: 90.65,
    width: 3.63,
    height: 11.92,
    transform: "translate(111.64 81.58) rotate(90)",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.31,
    y: 95.6,
    width: 3.63,
    height: 14.11,
    transform: "translate(118.78 86.52) rotate(90)",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.57,
    y: 102.39,
    width: 3.63,
    height: 12.62,
    transform: "translate(124.08 93.31) rotate(90)",
    style: {
      fill: "#dff3fa"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.83,3.28h0c1.65-1.65,4.31-1.65,5.96,0h0c1.29,1.29,1.6,3.26,.78,4.89l-2.63,5.18c-.47,.93-1.79,.93-2.26,0l-2.63-5.18c-.83-1.63-.51-3.6,.78-4.89Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.81,
    cy: 6.02,
    r: 2.02,
    style: {
      fill: "#b2dbf7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.83,18.54h0c1.65-1.65,4.31-1.65,5.96,0h0c1.29,1.29,1.6,3.26,.78,4.89l-2.63,5.18c-.47,.93-1.79,.93-2.26,0l-2.63-5.18c-.83-1.63-.51-3.6,.78-4.89Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.81,
    cy: 21.28,
    r: 2.02,
    style: {
      fill: "#b2dbf7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,121.09l-4.88-3.56-4.69,3.56v13.51H14.5v-13.51Zm-5.81-.94c0-.52,.42-.94,.94-.94s.94,.42,.94,.94-.42,.94-.94,.94-.94-.42-.94-.94Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.68,121.09l-4.88-3.56-4.69,3.56v13.51h9.57v-13.51Zm-5.81-.94c0-.52,.42-.94,.94-.94s.94,.42,.94,.94-.42,.94-.94,.94-.94-.42-.94-.94Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 13.29,
    cy: 54.81,
    r: 6.64,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.63,52.58c.52,.06,.94,.27,1.16,.58,.04,.06,.06,.13,.06,.21,0,.19-.15,.34-.35,.34-.09,0-.18-.05-.28-.14-.2-.19-.54-.34-.9-.34-.54,0-.74,.25-.74,.51,0,.85,2.35,.45,2.35,2.06,0,.71-.45,1.17-1.32,1.26v.36c0,.17-.14,.3-.3,.3s-.3-.14-.3-.3v-.36c-.63-.08-1.12-.41-1.34-.77-.03-.05-.05-.12-.05-.18,0-.19,.15-.35,.34-.35,.14,0,.22,.08,.28,.14,.27,.27,.61,.49,1.06,.49,.59,0,.87-.19,.87-.59,0-.94-2.35-.51-2.35-2.06,0-.57,.36-1.07,1.19-1.16v-.37c0-.17,.14-.3,.3-.3s.3,.14,.3,.3v.37Z",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.29,
    cy: 54.81,
    r: 5.04,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 13.29,
    y1: 48.17,
    x2: 13.29,
    y2: 48.66,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.29,
    y1: 60.95,
    x2: 13.29,
    y2: 61.45,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.94,
    y1: 54.81,
    x2: 19.44,
    y2: 54.81,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.15,
    y1: 54.81,
    x2: 6.65,
    y2: 54.81,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 17.99,
    y1: 50.11,
    x2: 17.64,
    y2: 50.46,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.95,
    y1: 59.15,
    x2: 8.6,
    y2: 59.5,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.99,
    y1: 59.5,
    x2: 17.64,
    y2: 59.15,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.95,
    y1: 50.46,
    x2: 8.6,
    y2: 50.11,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "100.49 134.57 35.19 134.57 35.19 36.51 83.61 36.51 100.49 60.34 100.49 134.57",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.19,
    y: 36.51,
    width: 3.48,
    height: 98.06,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.66 57.1 96.66 134.52 100.64 134.52 100.64 62.71 96.66 57.1",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.64 60.29 83.75 60.29 83.75 36.46 100.64 60.29",
    style: {
      fill: "#5e9fe1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.64 134.52 35.33 134.52 35.33 36.46 83.75 36.46 100.64 60.29 100.64 134.52",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.94px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.31 60.29 100.64 60.29 83.75 36.46 83.75 42.57 96.31 60.29",
    style: {
      fill: "#4194d8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.64 60.29 83.75 60.29 83.75 36.46 100.64 60.29",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.94px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 62.6,
    y1: 52.68,
    x2: 65.14,
    y2: 52.68,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.6,
    y1: 47.59,
    x2: 65.14,
    y2: 47.59,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.56,
    cy: 47.59,
    r: 1.01,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.56,
    cy: 52.68,
    r: 1.01,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.56,
    y1: 48.6,
    x2: 60.56,
    y2: 51.66,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 71.06,
    y1: 51.33,
    x2: 73.61,
    y2: 51.33,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.06,
    y1: 52.68,
    x2: 73.61,
    y2: 52.68,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.06,
    y1: 54.03,
    x2: 72.46,
    y2: 54.03,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 71.06,
    y1: 46.24,
    x2: 73.61,
    y2: 46.24,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.06,
    y1: 47.59,
    x2: 73.61,
    y2: 47.59,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.06,
    y1: 48.93,
    x2: 72.46,
    y2: 48.93,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 69.03,
    cy: 47.59,
    r: 1.01,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.03,
    cy: 52.68,
    r: 1.01,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.03,
    y1: 48.6,
    x2: 69.03,
    y2: 51.66,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 43.38,
    y: 43.44,
    width: 32.87,
    height: 13.38,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 45.74,
    y1: 45.29,
    x2: 49.03,
    y2: 45.29,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.74,
    y1: 47.34,
    x2: 49.03,
    y2: 47.34,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.74,
    y1: 49.38,
    x2: 47.55,
    y2: 49.38,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 51.82,
    y1: 45.29,
    x2: 55.11,
    y2: 45.29,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.82,
    y1: 47.34,
    x2: 55.11,
    y2: 47.34,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.82,
    y1: 49.38,
    x2: 53.63,
    y2: 49.38,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "47.93 54.5 47.93 52.75 46.42 51.88 44.91 52.75 44.91 54.5 46.42 55.37 47.93 54.5",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.61 54.5 51.61 52.75 50.1 51.88 48.59 52.75 48.59 54.5 50.1 55.37 51.61 54.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.3 54.5 55.3 52.75 53.79 51.88 52.28 52.75 52.28 54.5 53.79 55.37 55.3 54.5",
    style: {
      fill: "#b2dbf7"
    }
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 43.38,
    y1: 60.29,
    x2: 76.25,
    y2: 60.29,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.38,
    y1: 62.54,
    x2: 76.25,
    y2: 62.54,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.38,
    y1: 64.8,
    x2: 63.87,
    y2: 64.8,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 47.79,
    y1: 71.03,
    x2: 47.79,
    y2: 102.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 48.9,
    y1: 72.18,
    x2: 47.79,
    y2: 72.18,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.9,
    y1: 74.42,
    x2: 47.79,
    y2: 74.42,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.9,
    y1: 76.67,
    x2: 47.79,
    y2: 76.67,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.9,
    y1: 78.92,
    x2: 47.79,
    y2: 78.92,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.9,
    y1: 81.17,
    x2: 47.79,
    y2: 81.17,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.9,
    y1: 83.42,
    x2: 47.79,
    y2: 83.42,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.9,
    y1: 85.66,
    x2: 47.79,
    y2: 85.66,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.9,
    y1: 87.91,
    x2: 47.79,
    y2: 87.91,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.9,
    y1: 90.16,
    x2: 47.79,
    y2: 90.16,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.9,
    y1: 92.41,
    x2: 47.79,
    y2: 92.41,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.9,
    y1: 94.66,
    x2: 47.79,
    y2: 94.66,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.9,
    y1: 96.91,
    x2: 47.79,
    y2: 96.91,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.9,
    y1: 99.15,
    x2: 47.79,
    y2: 99.15,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "79.31 102.55 47.79 102.55 35.37 117.12",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 51.19,
    y1: 101.44,
    x2: 51.19,
    y2: 102.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.44,
    y1: 101.44,
    x2: 53.44,
    y2: 102.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.69,
    y1: 101.44,
    x2: 55.69,
    y2: 102.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.93,
    y1: 101.44,
    x2: 57.93,
    y2: 102.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.18,
    y1: 101.44,
    x2: 60.18,
    y2: 102.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.43,
    y1: 101.44,
    x2: 62.43,
    y2: 102.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.68,
    y1: 101.44,
    x2: 64.68,
    y2: 102.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.93,
    y1: 101.44,
    x2: 66.93,
    y2: 102.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.17,
    y1: 101.44,
    x2: 69.17,
    y2: 102.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.42,
    y1: 101.44,
    x2: 71.42,
    y2: 102.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.67,
    y1: 101.44,
    x2: 73.67,
    y2: 102.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.92,
    y1: 101.44,
    x2: 75.92,
    y2: 102.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.17,
    y1: 101.44,
    x2: 78.17,
    y2: 102.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 46.06,
    y1: 103.47,
    x2: 46.06,
    y2: 104.58,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.63,
    y1: 105.13,
    x2: 44.63,
    y2: 106.24,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.19,
    y1: 106.79,
    x2: 43.19,
    y2: 107.9,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.76,
    y1: 108.46,
    x2: 41.76,
    y2: 109.57,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.32,
    y1: 110.12,
    x2: 40.32,
    y2: 111.23,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.89,
    y1: 111.78,
    x2: 38.89,
    y2: 112.89,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.45,
    y1: 113.45,
    x2: 37.45,
    y2: 114.56,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.02,
    y1: 115.11,
    x2: 36.02,
    y2: 116.22,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "39.7 45.5 30.96 45.5 30.96 122.07 35.33 130 39.7 122.07 39.7 45.5",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.33 130 37.74 121.19 39.7 122.07 35.33 130",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.33 130 31.89 121.65 30.96 122.07 35.33 130",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.33,130l-1.92-3.49c.6-.21,1.25-.32,1.92-.32s1.32,.11,1.92,.32l-1.92,3.49Z",
    style: {
      fill: "#5e9fe1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.7 45.5 30.96 45.5 30.96 122.07 35.33 130 39.7 122.07 39.7 45.5",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.98 120.85 33.67 120.85 30.96 122.07 30.96 45.5 33.67 43.44 36.98 43.44 39.7 45.5 39.7 122.07 36.98 120.85",
    style: {
      fill: "#5e9fe1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.98 47.85 33.67 47.85 30.96 49.07 30.96 45.5 33.67 43.44 36.98 43.44 39.7 45.5 39.7 49.07 36.98 47.85",
    style: {
      fill: "#91c0db"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.98 120.85 36.98 43.44 39.7 45.5 39.7 122.07 36.98 120.85",
    style: {
      fill: "#4194d8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.98 47.85 33.67 47.85 30.96 49.07 30.96 45.5 33.67 43.44 36.98 43.44 39.7 45.5 39.7 49.07 36.98 47.85",
    style: {
      fill: "#91c0db"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.98 47.85 36.98 43.44 39.7 45.5 39.7 49.07 36.98 47.85",
    style: {
      fill: "#7ab2ce"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.98 48.83 33.67 48.83 30.96 50.06 30.96 48.69 33.67 46.63 36.98 46.63 39.7 48.69 39.7 50.06 36.98 48.83",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.98 120.85 33.67 120.85 30.96 122.07 30.96 45.5 33.67 43.44 36.98 43.44 39.7 45.5 39.7 122.07 36.98 120.85",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "30.96 49.07 30.96 45.5 33.67 43.44 36.98 43.44 39.7 45.5 39.7 49.07",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.67,
    y1: 120.85,
    x2: 33.67,
    y2: 43.44,
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.98,
    y1: 120.85,
    x2: 36.98,
    y2: 43.44,
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.98 48.83 33.67 48.83 30.96 50.06 30.96 48.69 33.67 46.63 36.98 46.63 39.7 48.69 39.7 50.06 36.98 48.83",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 55.14,
    y1: 125.54,
    x2: 59.54,
    y2: 125.54,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.14,
    y1: 127.65,
    x2: 59.54,
    y2: 127.65,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.14,
    y1: 129.76,
    x2: 57.75,
    y2: 129.76,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 55.14,
    y1: 117.59,
    x2: 59.54,
    y2: 117.59,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.14,
    y1: 119.69,
    x2: 59.54,
    y2: 119.69,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.14,
    y1: 121.8,
    x2: 57.75,
    y2: 121.8,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 51.97,
    cy: 119.69,
    r: 1.58,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.97,
    cy: 127.65,
    r: 1.58,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.97,
    y1: 121.28,
    x2: 51.97,
    y2: 126.07,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 68.16,
    y1: 125.54,
    x2: 72.56,
    y2: 125.54,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.16,
    y1: 127.65,
    x2: 72.56,
    y2: 127.65,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.16,
    y1: 129.76,
    x2: 70.77,
    y2: 129.76,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 68.16,
    y1: 117.59,
    x2: 72.56,
    y2: 117.59,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.16,
    y1: 119.69,
    x2: 72.56,
    y2: 119.69,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.16,
    y1: 121.8,
    x2: 70.77,
    y2: 121.8,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 64.99,
    cy: 119.69,
    r: 1.58,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.99,
    cy: 127.65,
    r: 1.58,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.99,
    y1: 121.28,
    x2: 64.99,
    y2: 126.07,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 81.19,
    y1: 125.54,
    x2: 85.58,
    y2: 125.54,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.19,
    y1: 127.65,
    x2: 85.58,
    y2: 127.65,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.19,
    y1: 129.76,
    x2: 83.79,
    y2: 129.76,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 81.19,
    y1: 117.59,
    x2: 85.58,
    y2: 117.59,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.19,
    y1: 119.69,
    x2: 85.58,
    y2: 119.69,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.19,
    y1: 121.8,
    x2: 83.79,
    y2: 121.8,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 78.01,
    cy: 119.69,
    r: 1.58,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.01,
    cy: 127.65,
    r: 1.58,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.01,
    y1: 121.28,
    x2: 78.01,
    y2: 126.07,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.29,
    y: 71.35,
    width: 17.53,
    height: 17.53,
    style: {
      fill: "#91c0db"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.78,
    y: 71.35,
    width: 2.03,
    height: 17.53,
    style: {
      fill: "#7ab2ce"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.29,
    y: 71.35,
    width: 17.53,
    height: 17.53,
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.94px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 78.08,
    y: 71.35,
    width: 17.53,
    height: 17.53,
    rx: 8.76,
    ry: 8.76,
    style: {
      fill: "#91c0db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.84,71.35h0c-.37,0-.73,.03-1.09,.07,4.33,.54,7.68,4.22,7.68,8.69h0c0,4.47-3.35,8.16-7.68,8.69,.36,.04,.72,.07,1.09,.07h0c4.84,0,8.76-3.92,8.76-8.76h0c0-4.84-3.92-8.76-8.76-8.76Z",
    style: {
      fill: "#7ab2ce"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.08,
    y: 71.35,
    width: 17.53,
    height: 17.53,
    rx: 8.76,
    ry: 8.76,
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.94px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "76.27 94.16 65.31 113.14 87.23 113.14 76.27 94.16",
    style: {
      fill: "#91c0db"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.27 94.16 75.43 95.62 85.55 113.14 87.23 113.14 76.27 94.16",
    style: {
      fill: "#4194d8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.95 94.49 75.1 95.94 85.22 113.47 86.91 113.47 75.95 94.49",
    style: {
      fill: "#7ab2ce"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.27 94.16 65.31 113.14 87.23 113.14 76.27 94.16",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.94px"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.3146260a399b644da6656f2ea5b36061.svg";
export { ForwardRef as ReactComponent };